import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
//Store
import { useTrackedState } from "../../store";
//Apis
import getUrlParam from '../../utilities/function/getUrl';
//Funciones
import buscarElementos from './../../utilities/function/buscarElementos';
//Hooks y funciones personalizadas
import useObtenerSubsecciones from './../helpers/hooks/useObtenerSubsecciones';
//Componentes
import CursosComponent from "../../components/cursos";
import listarArray from '../../utilities/function/listarElementos/listarArray';
import SkeletonCursos from '../../components/cursos/SkeletonsCursos/SkeletonCursos';


const GeneralCursos = (props) => {
  const { isLoadingCursos } = props;
  //Estados globales
  const state = useTrackedState();
  const { datosCursos, datosInstitucion } = state;


  //Estados del componente  
  const [isErrorSede, setIsErrorSede] = useState(false);
  const [filtros, setFiltros] = useState({
    sede: null
  });
  const [resultadosBusqueda, setResultadosBusqueda] = useState({
    hayResultados: true,
    resultados: []
  });
  const [sedes, setSedes] = useState([]);
  const [todosLosCursos, setTodosLosCursos] = useState([]);


  //Hooks personalizado para el llamado inicial de los datos en el container
  const { isReady, textosSubSecciones: textosInterfaz } = useObtenerSubsecciones('cursos')


  const history = useHistory();

  //Transforma la información de las sedes en un array
  useEffect(() => {
    const listaSedes = listarArray({ array: datosInstitucion.sedes });
    setSedes(listaSedes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  //Actualiza todos los resultados
  useEffect(() => {
    resultadosCursos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datosCursos])


  //Actualiza todos los resultados
  useEffect(() => {
    if (filtros.sede === null) {
      buscarCursos({ idSede: filtros.sede, value: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros])


  //Borrar filtros
  const borrarFiltros = ({ refInput }) => {
    refInput.value = '';

    history.push('/cursos');
    setIsErrorSede(false);
    setFiltros({ ...filtros, sede: null });
  }


  //Buscador para los cursos
  const buscarCursos = ({ idSede, value }) => {
    const sede = !!idSede ? idSede : filtros.sede;
    const datos = !!sede ? datosCursos : todosLosCursos;
    const resultados = buscarElementos({ datos, propiedad: 'cursos', sede, value });

    const resultadoBusqueda = {
      hayResultados: resultados.hayResultados,
      resultados: resultados.resultados
    }

    setResultadosBusqueda(resultadoBusqueda);
  }


  //Cambiar sede
  const cambiarSede = ({ idSede, value }) => {
    const sede = !!idSede ? idSede : null;
    if (sede !== null) {
      setIsErrorSede(false);
      buscarCursos({ idSede, value })
      setFiltros({ ...filtros, sede });
    } else {
      setIsErrorSede(false);
      setFiltros({ ...filtros, sede: null });
    }

  }


  const resultadosCursos = () => {
    if (!!datosCursos) {
      const param = getUrlParam('sede');
      const sede = !!param ? param : null;

      let todosLosCursos = [];
      for (const sede in datosCursos) {
        const cursosSede = datosCursos[sede].cursos;
        todosLosCursos = todosLosCursos.concat(cursosSede);
      }
      let resultados = {
        hayResultados: true,
        resultados: todosLosCursos
      };


      if (!!param) {
        const errorSede = !!datosCursos[param] ? false : true;
        resultados = {
          hayResultados: !!datosCursos[param] ? true : false,
          resultados: !!datosCursos[param] ? datosCursos[param].cursos : []
        };
        setIsErrorSede(errorSede);
      }

      setFiltros({ ...filtros, sede });
      setResultadosBusqueda(resultados);
      setTodosLosCursos(todosLosCursos)
    }
  }

  return (
    <>
      {
        isReady && !isLoadingCursos ?

          <CursosComponent
            borrarFiltros={borrarFiltros}
            buscarCursos={buscarCursos}
            cambiarSede={cambiarSede}
            filtros={filtros}
            isErrorSede={isErrorSede}
            resultadosBusqueda={resultadosBusqueda}
            sedes={sedes}
            textosInterfaz={{
              botones: textosInterfaz.botones,
              info_curso: textosInterfaz.info_curso,
              miga_de_pan: textosInterfaz.miga_de_pan,
              no_existe_sede: textosInterfaz.no_existe_sede,
              nuevo: textosInterfaz.nuevo,
              vista_general: textosInterfaz.vista_general,
            }}
          />
          :
          <SkeletonCursos />

      }
    </>
  )
}

export default GeneralCursos;